import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "#87857E",
  },
};

const ClosePopup = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };

  return (
    <svg {...mergedSvgProps}>
      <rect
        x="1"
        y="1"
        width="38"
        height="38"
        rx="19"
        fill="white"
        stroke="#E1DDD1"
        strokeWidth="2"
      />
      <path
        d="M25.864 27.5001L27.5001 25.864L21.6361 20L27.5001 14.136L25.864 12.4999L20 18.3639L14.136 12.4999L12.4999 14.136L18.3639 20L12.4999 25.864L14.136 27.5001L20 21.6361L25.864 27.5001Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default ClosePopup;
